<template>
  <div :style="style"></div>
</template>
<script lang="ts">
export default {
  name: 'Spacer',
};
</script>
<script setup lang="ts">
const props = defineProps({
  h: String,
  w: String,
  inline: Boolean,
});
const style = computed(() => {
  let css: { [k in string]: any } = {};
  if (props.w) {
    css.width = props.w + 'px';
  }
  if (props.h) {
    css.height = props.h + 'px';
  }
  if (props.inline) {
    css.display = 'inline-block';
  }
  return css;
});
</script>
